/* eslint-disable no-console */
import { setAttributes } from '../analytics/analytics.utils';
import { reset } from '../player/player.constants';
import { removePairing } from './customer/default/pairingProvider.actions';

export const PAIRING_LOGOUT_SUCCESS = 'pairing/LOGOUT_SUCCESS';

export const PAIRING_LOGOUT_FAILURE = 'pairing/LOGOUT_FAILURE';

export const PAIRING_RESET = 'pairing/RESET';

export const logoutSuccess = () => ({ type: PAIRING_LOGOUT_SUCCESS });

export const logoutFailure = error => ({ type: PAIRING_LOGOUT_FAILURE, error });

export const logout = () => async dispatch => {
  try {
    console.log('[unpair.actions] Removing pairing');
    await dispatch(removePairing());

    console.log('[unpair.actions] Resetting player state');
    dispatch(reset());

    console.log('[unpair.actions] Resetting analytics state');
    setAttributes({ authentified: 'no', userStatus: 'unknown' });

    console.log('[unpair.actions] Dispatching logout success');
    dispatch(logoutSuccess());
  } catch (error) {
    dispatch({ type: PAIRING_LOGOUT_FAILURE, error });
  } finally {
    console.log('[unpair.actions] Resetting local paring state');
    dispatch({ type: PAIRING_RESET });
  }
};
